import { useAppDispatch, useAppSelector } from '@hooks/redux';
import { useGetParams } from '@hooks/envelopes/useGetParams';
import { closeLoader, showLoader } from '@store/modules/loader';
import { getEnvelope, getEnvelopes, resetCurrentBoxOguid } from '@store/modules/envelopes';
import { catchThunkError } from '@utils/utils';

export const useLoadEnvelopes = () => {
  const dispatch = useAppDispatch()
  const { profile } = useAppSelector(state => state.user)

  const {
    direction,
    boxOguid,
    folder,
    page,
    perPage,
    oguid,
    otherSearchParams
  } = useGetParams()

  const loadEnvelopes = (): void => {
    dispatch(showLoader())

    !folder &&
      dispatch(getEnvelopes({ direction, boxOguid, page, perPage, otherSearchParams })).unwrap()
        .catch(err => {
          catchThunkError(err);
          dispatch(resetCurrentBoxOguid());
        })
        .finally(() => dispatch(closeLoader()))
  }

  const loadCurrentEnvelope = () => {
    dispatch(showLoader())
    const envelopeBoxOguid = boxOguid ?? profile.boxOguid

    oguid && envelopeBoxOguid && dispatch(getEnvelope({ oguid, boxOguid: envelopeBoxOguid })).unwrap()
      .catch(catchThunkError)
      .finally(() => dispatch(closeLoader()))
  }

  return { loadEnvelopes, loadCurrentEnvelope }
}
